<h2>{{ 'new_antrag.stepper.label.first_step.head.title' | translate }}</h2>
<p
  [innerHTML]="
    'new_antrag.stepper.label.first_step.head.description'
      | translate
        : {
            maximumFileSizeInMb: maximumFileSizeInMb,
            maximumAntragSizeInMb: maximumAntragSizeInMb,
          }
      | bypassSecurityPipe: 'html'
  "
  class="translation-text"></p>

@if ('new_antrag.stepper.lang_antrag_info' | translate; as infotext) {
  <mat-card appearance="outlined" class="info-card translation-text">
    <mat-card-content>
      <mat-icon aria-hidden="true" class="info-card__icon">info</mat-icon>
      <div [innerHTML]="infotext | bypassSecurityPipe: 'html'"></div>
    </mat-card-content>
  </mat-card>
}

<p class="next-step-button button-row">
  <button (click)="next()" color="primary" mat-flat-button>
    {{ 'new_antrag.button.start_with_einreichung' | translate }}
  </button>
</p>
